var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 45,
    viewBox: "0 0 56 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 33.2499L52.5 33.2499",
    stroke: "#FFA345",
    strokeWidth: 5.4,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 8.5L41.25 17.5L27.75 4L14.25 17.5L3 8.5L3 37.75C3 38.9435 3.47411 40.0881 4.31802 40.932C5.16193 41.7759 6.30653 42.25 7.5 42.25L48 42.25C49.1935 42.25 50.3381 41.7759 51.182 40.932C52.0259 40.0881 52.5 38.9435 52.5 37.75L52.5 8.5Z",
    stroke: "#FFA345",
    strokeWidth: 5.4,
    strokeMiterlimit: 10,
    strokeLinecap: "square",
    fill: "#FFA345"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.1f78fdd53b5a2f0c6410f9af32910da8.svg";
export { ForwardRef as ReactComponent };